import React, { Component } from 'react';
import autobind from 'autobind-decorator'
import { connect } from 'react-redux'
import { closePopup } from '../../../actions/popup';
import classnames from 'classnames';
import querystring from 'querystring';
import { receiveItems } from '../../../actions/comment/comment'
import TTextareaForm from "../../common/TTextareaForm";
import { jsonResponseHandler } from '../../../utils/FetchHelper'
import {addPrefix} from "../../../utils/UriUtil";

@connect(state => ({
	items: state.comment.item.items,
	isCommentReplyPopupOpened: state.popup.isCommentReplyPopupOpened,
	id: state.popup.commentReplyPopupCommentIds
}), dispatch => ({
	handlePopupClose: () => {
		dispatch(closePopup())
	},
	handleReceiveItems: (items, totalCount) => {
		dispatch(receiveItems(items, totalCount))
	},
    dispatch
}))
class CommentReplyPopup extends Component {
    constructor() {
        super();
        this.state = {
            comment : ''
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSaveComment = this.handleSaveComment.bind(this);
        this.reFetchItems = this.reFetchItems.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.clearComment = this.clearComment.bind(this);
    }

    componentWillReceiveProps(nextProps) {

        if (this.props.isCommentReplyPopupOpened === false &&
            nextProps.isCommentReplyPopupOpened === true)

            this.setState({
                comment: ''
            });
    }

    clearComment() {
        this.setState({
            comment: ''
        });

    }

    closePopup(e) {

        this.clearComment();
        this.props.handlePopupClose();
    }

    handleChange(value) {
        this.setState({comment: value});
    }

    handleSaveComment(e) {

        const { dispatch } = this.props;

        fetch(addPrefix("/manage/comment/"+this.props.id+"/reply.json"), {
            method: "post",
            credentials: "include",
            headers: {'Content-Type':'application/x-www-form-urlencoded'},
            body: querystring.stringify({
                comment: this.state.comment
            })
        })
            .then(
              jsonResponseHandler(dispatch))
            .then(data => {
                this.clearComment();
                this.props.handlePopupClose();
                this.reFetchItems();
            })
            .catch(e => {
                console.log(e)
            })
    }

    reFetchItems() {

        const { dispatch } = this.props;

        fetch(addPrefix("/manage/comments.json") + location.search, {
            method: 'GET',
            credentials: 'include'
        })
            .then(jsonResponseHandler(dispatch))
            .then(r => r.json())
            .then(data => {
                this.props.handleReceiveItems(data.items, data.totalCount)
            })
            .catch(e => {
                console.log(e)
            })
    }

    render() {

        const { comment } = this.state;

        return (
            <div className="blog_layer" style={{position: 'fixed', top: '50%', marginTop: '-112px', display: this.props.isCommentReplyPopupOpened?'block':'none'}}>
                <div className="inner_blog_layer inner_blog_layer1">
                    <form>
                        <div className="cont_layer">
                            <strong className="tit_popup">답글 쓰기</strong>
                            <TTextareaForm className="tf_blog" onChange={this.handleChange} value={comment}/>
                        </div>
                        <div className="fld_btn">
                            <button type="button" className="btn_cancel" onClick={this.closePopup}>취소</button>
                            <button type="button" className={classnames('btn_default', {btn_off : !this.state.comment})} disabled={!this.state.comment} onClick={this.handleSaveComment}>확인</button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default CommentReplyPopup
